import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const url = 'https://us-central1-bookstore-api-e63c8.cloudfunctions.net/bookstoreApi/apps/FGaMsvX3Tg1PCUHSGUWu/books';

export const fetchData = createAsyncThunk('books/fetchData', async() => {
  const response = await axios.get(url);
  const fetchedBooks = Object.entries(response.data).map((value) => {
     return {
      ...value[1][0],
      item_id: value[0],
      };
  })
  return fetchedBooks;
});

export const addNewBook = createAsyncThunk('books/addNewBook', async(newBook) => {
  await axios.post(url, newBook)
  return newBook;
});

export const removeBook = createAsyncThunk('books/removeBook', async(bookId) => {
  await axios.delete(`${url}/${bookId}`, bookId)
  return bookId;
});

const initialState = [];

export const booksSlice = createSlice({
  name: 'books',
  initialState,
  // reducers: {
  //   addBook: (state, action) => {
  //     return ([...state, action.payload]);
  //   },
  //   removeBook: (state, action) => state.filter(book => book.item_id !== action.payload),
  // },
  extraReducers(builder) {
    builder
      .addCase(fetchData.fulfilled, (state, action) => {
        return state = action.payload;
      })
      .addCase(addNewBook.fulfilled, (state, action) => {
        state = state.push(action.payload);
      })
      .addCase(removeBook.fulfilled, (state, action) => {
        return state = state.filter(item => item.item_id !== action.payload);
      })
  }
});

// export const { addBook, removeBook } = booksSlice.actions;
export default booksSlice.reducer;